export const firebaseAppScript =
  "https://www.gstatic.com/firebasejs/8.2.3/firebase-app.js";
export const firebaseMsgScript =
  "https://www.gstatic.com/firebasejs/8.2.3/firebase-messaging.js";
